import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { errorDispatch } from "../../../functions/errorDispatch";
import i18n from "../../../functions/i18next";

export default {
  props: {
    selectedFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      id: this.$options.name,
      collections: [],
    };
  },
  created() {
    this.$axios.get(`${baseUrl}/collectionsall`).then((r) => {
      this.collections = r.data;
    });

    EventBus.$on(`${this.id}-select-collection`, (data) => {
      this.addFileToCollections();
    });
  },
  methods: {
    addFileToCollections() {
      const formData = new FormData();
      const selectedCollections = new FormData(this.$refs.selectedCollections);

      //add files to the form data
      formData.append("files", JSON.stringify(this.selectedFiles));

      formData.append(
        "collections",
        JSON.stringify(
          Array.from(selectedCollections.entries()).map(
            (collection) => collection[1]
          )
        )
      );

      this.$axios
        .post(`${baseUrl}/collectionaddmultiple`, formData)
        .then((r) => {
          //open the next window (collection-success)
          EventBus.$emit(`updateOverlayPageStep`, {
            id: "collect-file",
            activeStepId: "collection-success",
            collections: this.collections.filter((col) =>
              formData.get("collections").includes(col.id)
            ),
          });
        })
        .catch((e) => {
          errorDispatch("collect_selected");
        });
    },
  },
};
